// extracted by mini-css-extract-plugin
export default {"rating":"FinishStage_rating__UG05b","ratingText":"FinishStage_ratingText__rJAvl","controls":"FinishStage_controls__2WL9N","controlsButton":"FinishStage_controlsButton__MbO-O"};